export default "__VITE_ASSET__ChkpfF3C__"